/**
 * Map venue registry: resolve fixture city/venue pairs to stable mapVenueId slugs.
 * Aliases live in models/mapVenueAliases.json (shared with Python maintenance scripts).
 */
import venueAliasesJson from '@/models/mapVenueAliases.json';
import mapVenueCoordinates from '@/models/mapVenueCoordinates.json';
import type { MapVenue } from '@/models/mapVenue';
import { getMapVenues } from '@/models/mapVenue';

export const VENUE_ALIASES: Record<string, string> = venueAliasesJson;

export function normalizeVenueName(venueName: string): string {
  return VENUE_ALIASES[venueName] ?? venueName;
}

function buildCityVenueToId(): Map<string, string> {
  const map = new Map<string, string>();
  for (const entry of mapVenueCoordinates) {
    const key = `${entry.cityName}\0${entry.venueName}`;
    map.set(key, entry.id);
  }
  return map;
}

const cityVenueToId = buildCityVenueToId();

/** Resolve a fixture location to a mapVenueId, or undefined if unknown. */
export function resolveMapVenueId(cityName: string | undefined, venueName: string | undefined): string | undefined {
  if (!cityName || !venueName) return undefined;
  const canonical = normalizeVenueName(venueName);
  return cityVenueToId.get(`${cityName}\0${canonical}`);
}

export function buildVenueIdToVenue(): Map<string, MapVenue> {
  return new Map(getMapVenues().map((venue) => [venue.id, venue]));
}
